import { render } from "./ShowDataset.vue?vue&type=template&id=e3f33424"
import script from "./ShowDataset.vue?vue&type=script&lang=js"
export * from "./ShowDataset.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__